<template>
  <div v-loading.fullscreen="loadingShow"> </div>   
</template>

<script>
export default {
  data() {
    return {
      params: {},
      loadingShow: true,
      error_message: ""
    }
  },
  created() {

    let url = window.location.href
    const _this = this

    // 失败

    if(this.getUrlParam('error_message', url)) {
      if(  this.getUrlParam('error_message', url).indexOf('#') > -1  ) {
        this.error_message = this.getUrlParam('error_message', url).split('#')[0]
      } else {
        this.error_message = this.getUrlParam('error_message', url)
      }
      this.loadingShow = false

      this.$message({
        message: this.getUrlParam('error_message', url).split('#')[0],
        duration: 0,
        showClose: true,
        onClose() {
          _this.$router.push({
            name: 'home'
          })
        }
      })
      return
    }
    
    
    if(  this.getUrlParam('code', url) && (this.getUrlParam('code', url).indexOf('#') > -1 ) ) {
      this.params.code = this.getUrlParam('code', url).split('#')[0]
    } else {
      this.params.code = this.getUrlParam('code', url)
    }

    if( this.getUrlParam('state', url) && (this.getUrlParam('state', url).indexOf('#') > -1)) {
      this.params.state = this.getUrlParam('state', url).split('#')[0]
    } else {
      this.params.state = this.getUrlParam('state', url)
    }
    this.params.type = this.$route.query.type
    this.userTrustLogin()
  },
  
  methods: {
    getUrlParam(name, url){
      let queryString = url.split("?")[1] || '',
        reg 		= new  RegExp("(^|&)" + name + "=([^&]*)(&|$)"),
        result 		= queryString.match(reg);

        
        return result ? decodeURIComponent(result[2]) : null;
    },
    userTrustLogin() {
			const _this = this
			let data = {
			  ...this.params,
        scope: 1,
        client: 'PC'
			};
      if(window.localStorage.getItem('invite')) {
        data.invitecode = window.localStorage.getItem('invite')
      }
			this.$api.getOpenId(data).then(res => {
				if (res.status) {
          this.loadingShow = false
					if (res.data.token) {
            this.$storage.set("userToken", res.data.token);
            this.$router.push({
              name: 'home'
            })
					} 
				} else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
				}
			});
		},
    //获取url参数
    getUrlParam(name, url){
      let queryString = url.split("?")[1] || '',
        reg 		= new  RegExp("(^|&)" + name + "=([^&]*)(&|$)"),
        result 		= queryString.match(reg);
        return result ? decodeURIComponent(result[2]) : null;
    },
  }
}
</script>

<style>

</style>